<template>
    <report-field-row   :field-id="field.key"
                        :label="field.label"
                        :description="field.description"
                        :error="error"
    >
        <input  :id="field.key"
                :name="field.key"
                :value="modelValue"
                :placeholder="field.placeholder"
                type="text"
                class="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                @input="$emit('update:modelValue', $event.target.value)"
        >
    </report-field-row>
</template>

<script>
import ReportFieldRow from "../ReportFieldRow.vue"

export default {
    name: "ReportTextField",
    components: {ReportFieldRow},
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        field: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            default: null,
        },
    },
}
</script>
